import { AppContext } from '../../context';
import { Settings } from 'luxon';
import React, { useContext, useEffect } from 'react';
import Select, { ControlProps, OptionProps, components } from 'react-select';
import i18n from 'i18next';

import './styles.scss';

interface ControlPropsOpt {
    readonly value: string;
    readonly label: JSX.Element;
}

const Control = ({ children, ...props }: ControlProps<ControlPropsOpt, false>) => {
    return <components.Control {...props}>{children}</components.Control>;
};

const Option = ({ children, ...props }: OptionProps<ControlPropsOpt, false>) => {
    return <components.Option {...props}>{props.data.label}</components.Option>;
};

const ListLanguages: React.FC = () => {
    const { selectedLanguage, updateSelectedLanguage } = useContext(AppContext);

    useEffect(() => {
        Settings.defaultLocale = selectedLanguage;
        i18n.changeLanguage(selectedLanguage);
    }, [selectedLanguage]);

    const options: { value: string; label: JSX.Element }[] = [
        {
            value: 'en',
            label: (
                <div>
                    <img
                        className="languageListIcon"
                        alt="United States"
                        src="https://purecatamphetamine.github.io/country-flag-icons/1x1/US.svg"
                    />
                    <b>{'EN'}</b>
                    <span>{'English'}</span>
                </div>
            ),
        },
        {
            value: 'es',
            label: (
                <div>
                    <img
                        className="languageListIcon"
                        alt="Spain"
                        src="https://purecatamphetamine.github.io/country-flag-icons/1x1/ES.svg"
                    />
                    <b>{'ES'}</b>
                    <span>{'Spanish - español'}</span>
                </div>
            ),
        },
        {
            value: 'fr',
            label: (
                <div>
                    <img
                        className="languageListIcon"
                        alt="France"
                        src="https://purecatamphetamine.github.io/country-flag-icons/1x1/FR.svg"
                    />
                    <b>{'FR'}</b>
                    <span>{'French - Français'}</span>
                </div>
            ),
        },
        {
            value: 'it',
            label: (
                <div>
                    <img
                        className="languageListIcon"
                        alt="Italy"
                        src="https://purecatamphetamine.github.io/country-flag-icons/1x1/IT.svg"
                    />
                    <b>{'IT'}</b>
                    <span>{'Italian - Italiano'}</span>
                </div>
            ),
        },
        {
            value: 'sw',
            label: (
                <div>
                    <img
                        className="languageListIcon"
                        alt="Swahili"
                        src="https://purecatamphetamine.github.io/country-flag-icons/1x1/KE.svg"
                    />
                    <b>{'SW'}</b>
                    <span>{'Swahili - Kiswahili'}</span>
                </div>
            ),
        },
        {
            value: 'zh',
            label: (
                <div>
                    <img
                        className="languageListIcon"
                        alt="Chinese Simplified"
                        src="https://purecatamphetamine.github.io/country-flag-icons/1x1/CN.svg"
                    />
                    <b>{'ZH'}</b>
                    <span>{'Chinese - 中文'}</span>
                </div>
            ),
        },
        {
            value: 'pt',
            label: (
                <div>
                    <img
                        className="languageListIcon"
                        alt="Brazil"
                        src="https://purecatamphetamine.github.io/country-flag-icons/1x1/BR.svg"
                    />
                    <b>{'BR'}</b>
                    <span>{'Portuguese - português'}</span>
                </div>
            ),
        },
        {
            value: 'de',
            label: (
                <div>
                    <img
                        className="languageListIcon"
                        alt="Germany"
                        src="https://purecatamphetamine.github.io/country-flag-icons/1x1/DE.svg"
                    />
                    <b>{'DE'}</b>
                    <span>{'German - Deutsch'}</span>
                </div>
            ),
        },
        {
            value: 'nl',
            label: (
                <div>
                    <img
                        className="languageListIcon"
                        alt="Germany"
                        src="https://purecatamphetamine.github.io/country-flag-icons/1x1/NL.svg"
                    />
                    <b>{'NL'}</b>
                    <span>{'Dutch - Nederlands'}</span>
                </div>
            ),
        },
        {
            value: 'pl',
            label: (
                <div>
                    <img
                        className="languageListIcon"
                        alt="Poland"
                        src="https://purecatamphetamine.github.io/country-flag-icons/1x1/PL.svg"
                    />
                    <b>{'PL'}</b>
                    <span>{'Polish - Polski'}</span>
                </div>
            ),
        },
        {
            value: 'ko',
            label: (
                <div>
                    <img
                        className="languageListIcon"
                        alt="Korea"
                        src="https://purecatamphetamine.github.io/country-flag-icons/1x1/KR.svg"
                    />
                    <b>{'KR'}</b>
                    <span>{'Korean - 한국어'}</span>
                </div>
            ),
        },
        {
            value: 'ja',
            label: (
                <div>
                    <img
                        className="languageListIcon"
                        alt="Japan"
                        src="https://purecatamphetamine.github.io/country-flag-icons/1x1/JP.svg"
                    />
                    <b>{'JA'}</b>
                    <span>{'Japanese - 日本'}</span>
                </div>
            ),
        },
    ];

    return (
        <Select
            placeholder="Select a language"
            className="listLanguages"
            classNamePrefix="timezone"
            value={options.find((val) => val.value === selectedLanguage)}
            name="languages"
            options={options}
            onChange={(opt) => updateSelectedLanguage(opt?.value || 'en')}
            components={{ Control, Option }}
            styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            menuPortalTarget={document.body}
        />
    );
};
export default ListLanguages;
